var callbacks = {
  onClose: function onClose() {},
  onError: function onError() {},
  onSuccess: function onSuccess() {},
  onLoading: function onLoading() {}
};
export { setCallback, clearCallbacks, getCallback };
function setCallback(name, cb) {
  // @ts-ignore
  callbacks[name] = cb;
}
function getCallback(name) {
  return callbacks[name];
}
function clearCallbacks() {
  setCallback('onClose', function () {});
  setCallback('onSuccess', function () {});
  setCallback('onError', function () {});
  setCallback('onLoading', function () {});
}